// this is an autogenerated file from App/Account/Topbar/Options/Content/OrdersAction/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Topbar_Options_Content_OrdersAction{
  orders_orders_aggregate {
    aggregate {
      count
    }
  }
}

`